/* KOJO storefront behaviour. No dependencies. */
(function () {
  'use strict';

  var mq = window.matchMedia('(max-width: 850px)');

  /* ---- Mobile drawer ---- */
  var menu = document.querySelector('[data-mobile-menu]');
  var scrim = document.querySelector('[data-scrim]');
  var openBtn = document.querySelector('[data-menu-open]');
  var closeBtn = document.querySelector('[data-menu-close]');

  function setMenu(open) {
    if (!menu) return;
    menu.classList.toggle('mobile-menu-open', open);
    if (scrim) scrim.hidden = !open;
    if (openBtn) openBtn.setAttribute('aria-expanded', String(open));
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }

  if (openBtn) openBtn.addEventListener('click', function () { setMenu(true); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setMenu(false); });
  if (scrim) scrim.addEventListener('click', function () { setMenu(false); closeMega(); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { setMenu(false); closeMega(); }
  });

  /* ---- Mobile accordions ---- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-accordion]'), function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.nextElementSibling;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      if (panel) panel.classList.toggle('mobile-submenu-open', !open);
    });
  });

  /* ---- Desktop mega menu ---- */
  var panels = document.querySelectorAll('[data-mega-panel]');

  function closeMega() {
    Array.prototype.forEach.call(panels, function (p) {
      p.classList.remove('mega-menu-open');
      p.hidden = true;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-mega-trigger]'), function (t) {
      t.setAttribute('aria-expanded', 'false');
    });
    if (scrim && !(menu && menu.classList.contains('mobile-menu-open'))) scrim.hidden = true;
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-mega-trigger]'), function (trigger) {
    trigger.addEventListener('click', function () {
      if (mq.matches) return;
      var id = trigger.getAttribute('data-mega-trigger');
      var panel = document.querySelector('[data-mega-panel="' + id + '"]');
      var isOpen = panel && panel.classList.contains('mega-menu-open');
      closeMega();
      if (panel && !isOpen) {
        panel.hidden = false;
        // force layout so the max-height transition runs
        void panel.offsetHeight;
        panel.classList.add('mega-menu-open');
        trigger.setAttribute('aria-expanded', 'true');
        if (scrim) scrim.hidden = false;
      }
    });
  });

  /* ---- Coming soon: reveal the store password field ---- */
  var pwToggle = document.querySelector('[data-password-toggle]');
  var pwPanel = document.querySelector('[data-password-panel]');
  if (pwToggle && pwPanel) {
    pwToggle.addEventListener('click', function () {
      var open = pwToggle.getAttribute('aria-expanded') === 'true';
      pwToggle.setAttribute('aria-expanded', String(!open));
      pwPanel.hidden = open;
      if (!open) {
        var field = pwPanel.querySelector('input[type="password"]');
        if (field) field.focus();
      }
    });
    // Keep it open when the password was wrong, so the error is visible.
    if (pwPanel.querySelector('.errors')) {
      pwToggle.setAttribute('aria-expanded', 'true');
      pwPanel.hidden = false;
    }
  }

  /* ---- Product: size selection ---- */
  var productRoot = document.querySelector('[data-product]');
  if (productRoot) {
    var variantInput = productRoot.querySelector('[data-variant-input]');
    var priceEl = productRoot.querySelector('[data-price]');
    var addBtn = productRoot.querySelector('[data-add]');
    var addText = productRoot.querySelector('[data-add-text]');

    Array.prototype.forEach.call(productRoot.querySelectorAll('[data-size]'), function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;

        Array.prototype.forEach.call(productRoot.querySelectorAll('[data-size]'), function (b) {
          b.classList.remove('size-active');
          b.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('size-active');
        btn.setAttribute('aria-checked', 'true');

        var id = btn.getAttribute('data-variant-id');
        if (variantInput && id) variantInput.value = id;
        if (priceEl) priceEl.textContent = btn.getAttribute('data-price') || priceEl.textContent;

        var available = btn.getAttribute('data-available') === 'true';
        if (addBtn) addBtn.disabled = !available;
        if (addText) addText.textContent = available ? 'Add to bag' : 'Sold out';

        var url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        window.history.replaceState({}, '', url);
      });
    });
  }
})();
